// extracted by mini-css-extract-plugin
export var content = "_mi-1";
export var fullScreen = "_mi-0";